import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'; // Import useDispatch and useSelector hooks
import { createType, updateType, clearMessages as clearTypeMessages } from '../../../redux/slices/admin/typesSlice'; // Import actions to create or update a type

const TypeModal = ({ isOpen, closeModal, initialData, isEditMode }) => {
    const dispatch = useDispatch(); // Initialize dispatch
    const [typeName, setTypeName] = useState(''); // Local state for type name

    // Get success and error messages from Redux store
    const successMessage = useSelector((state) => state.admin_types?.successMessage);
    const errorMessage = useSelector((state) => state.admin_types?.error);

    // Set initial data for editing
    useEffect(() => {
        if (isEditMode && initialData) {
            setTypeName(initialData.title || '');
        } else {
            setTypeName('');
        }
    }, [isEditMode, initialData]);

    const handleFormChange = (event) => {
        setTypeName(event.target.value); // Update type name state
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (isEditMode) {
            await dispatch(updateType({ id: initialData.id, type_name: typeName })); // Dispatch action to update type
        } else {
            await dispatch(createType({ type_name: typeName })); // Dispatch action to create type
        }
        closeModal(); // Close modal
    };

    const handleClose = () => {
        dispatch(clearTypeMessages()); // Clear messages before closing
        closeModal(); // Close modal
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block', paddingLeft: '0px' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-create" role="document">
                <div className="modal-content">
                    <div className="modal-header justify-content-center">
                        <h1 className="modal-title" id="modalNutritionTypesLabel">{isEditMode ? 'Edit Meal Type' : 'Create Meal Type'}</h1>
                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body px-md-5 pb-md-4">
                            <div className="row g-3 gx-md-5 gy-md-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        placeholder="Name"
                                        className="form-control form-control-lg"
                                        name="type_name"
                                        value={typeName}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-12">
                                    <button type="submit" className="btn btn-create w-100">{isEditMode ? 'Update' : 'Create'}</button>
                                </div>
                                <div className="col-md-12">
                                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default TypeModal;